var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoBuildinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.73 15.12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "co-building_inline_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "co-building_inline_svg__Capa_1-2",
    "data-name": "Capa 1",
    fill: "#fdc800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24 6.94h.96v1.77h-.96zm0 3.54h.96v1.77h-.96zm0-7.07h.96v1.77h-.96zm2.95 7.07h.96v1.77h-.96zm0-3.54h.96v1.77h-.96zm0-3.53h.96v1.77h-.96zm5.48 5.57h1.88v.96h-1.88zm0 2.36h1.88v.96h-1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.39 15.12h3.44a1.9 1.9 0 001.9-1.9v-7h-5.34V0H0v15.12h10.39zm4.38-8v6.06a.94.94 0 01-.94.94h-3.44v-7zM1 14.16V1h8.43v13.2z"
  })))));
}

export default SvgCoBuildinginline;